import {
    GetNotesForPersonaRequest,
    GetPersonaNotesResponse,
    getServiceAsync,
} from '../../../../service';
import { runOwsRequestWithMonitor, Feature } from '../../../../shared';
import { convertNotes } from './../converters/personaNotesConverter';

export default function getPrivateDistributionListNotes(
    pdlPersonaId: string,
    contactFolderId: string
): Promise<string> {
    return getServiceAsync().then(service => {
        const request: GetNotesForPersonaRequest = {
            EmailAddress: null,
            PersonaId: pdlPersonaId,
            MaxBytesToFetch: 512000,
        };

        // Parent folder is needed for Public Folders
        if (!!contactFolderId) {
            request.ParentFolderId = service.Factory.targetFolderId({
                BaseFolderId: service.Factory.folderId({ Id: contactFolderId }),
            });
        }

        return runOwsRequestWithMonitor({
            scenarioName: 'DistributionListsNotes',
            feature: Feature.PrivateDistributionList,
            operation: () => {
                return service.Operation.getNotesForPersonaOperation({
                    getNotesForPersonaRequest: request,
                });
            },
            transformResponse: (response: GetPersonaNotesResponse) => {
                const notes = convertNotes(response);

                // For PrivateDistributionList there is only one note
                return notes.length > 0 ? notes[0] : null;
            },
        });
    });
}
